// ToastContext.js
import { useContext } from 'react';
import { ToastContext } from './ToastProvider';

export const useToast = () => {
  const context = useContext(ToastContext);
  
  if (!context) {
    // Fallback to console logging if ToastProvider is not found
    console.error('ToastProvider not found. Wrap your app with ToastProvider.');
    
    return {
      showToast: (message, type = 'info') => {
        console.log(`Toast: ${type} - ${message}`);
        // Optionally, you can show a browser alert as fallback
        if (type === 'error') {
          alert(`Error: ${message}`);
        }
      },
      success: (message) => console.log(`✅ Toast: ${message}`),
      error: (message) => console.log(`❌ Toast: ${message}`),
      warning: (message) => console.log(`⚠️ Toast: ${message}`),
      info: (message) => console.log(`ℹ️ Toast: ${message}`),
    };
  }
  
  return context;
};